import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { rgb2arr } from '@antv/l7-utils';
import BaseModel from "../../core/BaseModel";
import { polygonTriangulation } from "../../core/triangulation";
/* babel-plugin-inline-import '../../shader/minify_frag.glsl' */
const mask_frag = "layout(std140) uniform commonUniorm {\n  vec4 u_color;\n  float u_opacity;\n};\n\nout vec4 outputColor;\n\nvoid main() {\n  outputColor = u_color;\n  outputColor.a *= u_opacity;\n}\n";
/* babel-plugin-inline-import '../shaders/mask_vert.glsl' */
const mask_vert = "layout(location = ATTRIBUTE_LOCATION_POSITION) in vec3 a_Position;\n\nlayout(std140) uniform commonUniorm {\n  vec4 u_color;\n  float u_opacity;\n};\n\n#pragma include \"projection\"\n\nvoid main() {\n  vec4 project_pos = project_position(vec4(a_Position, 1.0));\n  gl_Position = project_common_position_to_clipspace(vec4(project_pos.xyz, 1.0));\n}\n\n";
export default class MaskModel extends BaseModel {
  getUninforms() {
    const commoninfo = this.getCommonUniformsInfo();
    const attributeInfo = this.getUniformsBufferInfo(this.getStyleAttribute());
    this.updateStyleUnifoms();
    return _objectSpread(_objectSpread({}, commoninfo.uniformsOption), attributeInfo.uniformsOption);
  }
  getCommonUniformsInfo() {
    const {
      opacity = 1,
      color = '#000'
    } = this.layer.getLayerConfig();
    const commonOptions = {
      u_color: rgb2arr(color),
      u_opacity: opacity || 1
    };
    const commonBufferInfo = this.getUniformsBufferInfo(commonOptions);
    return commonBufferInfo;
  }
  initModels() {
    var _this = this;
    return _asyncToGenerator(function* () {
      return _this.buildModels();
    })();
  }
  buildModels() {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      _this2.initUniformsBuffer();
      const model = yield _this2.layer.buildLayerModel({
        moduleName: 'mask',
        vertexShader: mask_vert,
        fragmentShader: mask_frag,
        defines: _this2.getDefines(),
        triangulation: polygonTriangulation,
        depth: {
          enable: false
        },
        pick: false
      });
      return [model];
    })();
  }
  clearModels(refresh = true) {
    if (refresh) {
      this.layerService.clear();
    }
  }
  registerBuiltinAttributes() {
    return '';
  }
}